import httpClient from '@/http-client'

export const vendor = data => {
  return httpClient
    .get('/api/v1/reports/finances/vendors', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const payToVendor = data => {
  return httpClient
    .post('/api/v1/reports/finances/pay-to-vendors', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const incomeStatementDetail = data => {
  return httpClient
    .post('/api/v1/reports/finances/income-statment-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const grossProfit = data => {
  return httpClient
    .post('/api/v1/reports/finances/gross-profit', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const accountReceivable = data => {
  return httpClient
    .get('/api/v1/reports/finances/account-receivables', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  payToVendor,
  vendor,
  incomeStatementDetail,
  grossProfit,
  accountReceivable
}
